import { createNode, PlainDateDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromPlainDate } from '../../utils/temporal';

export const DateNode = createNode({
    id: 'Date',
    name: 'Date',
    description: 'Creates a Date value from year, month, and day components',
    aiDescription: 'Takes number inputs on the "Year", "Month", and "Day" ports and outputs a Date on the "Date" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Year: { kind: 'number' },
        Month: { kind: 'number' },
        Day: { kind: 'number' },
    },
    outPorts: {
        Date: PlainDateDataType,
    },
    execute: function (input) {
        const date = Temporal.PlainDate.from({
            year: input.inPorts.Year,
            month: Math.max(1, input.inPorts.Month),
            day: Math.max(1, input.inPorts.Day),
        });
        return { output: { Date: fromPlainDate(date) } };
    },
});
